import Vue from 'vue';
import { copyWithSnackbar } from '@/utils/clipboard';
import { getAuctionStatusClass } from '@/utils/auctionStatusUi';

export function copyBidInfoFromBidder(target, bidder) {
  target.name = bidder.tenderers[0].name;
  target.email = bidder.tenderers[0].contactPoint.email;
  target.bid = bidder.value.amount;
}

export function saveUpdatedBidInList(bids, updatedBid) {
  bids.forEach((item, index) => {
    if (item.id === updatedBid.id) {
      Vue.set(bids, index, updatedBid);
    }
  });
}

export function getBidderStatusClass(status) {
  return getAuctionStatusClass(status, '');
}

export function copyBidderText({ copyText, showSnackbar, text }) {
  return copyWithSnackbar({ copyText, showSnackbar, text });
}
